// ReadUsModal.js
import React, { useEffect, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import { useMediaQuery } from "react-responsive";
import "./detailsModal.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import { IoIosCloseCircleOutline } from "react-icons/io";

pdfjs.GlobalWorkerOptions.workerSrc = "/pdf.worker.mjs";

const DetailsModal = ({ isOpen, onClose, fileName }) => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const [numPages, setNumPages] = useState(null);
  const [currentFile, setCurrentFile] = useState(fileName);

  useEffect(() => {
    if (isOpen) {
      setCurrentFile(fileName);
    }
  }, [isOpen, fileName]);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal-content">
        <IoIosCloseCircleOutline
          className="close-button"
          onClick={onClose}
          style={{ fontSize: "30px", cursor: "pointer" }}
        />
        <Document
          key={currentFile}
          file={`/assets/pdfFiles/${currentFile}`}
          onLoadSuccess={onDocumentLoadSuccess}
        >
          {Array.from(new Array(numPages), (el, index) => (
            <Page
              key={index + 1}
              pageNumber={index + 1}
              renderAnnotationLayer={false}
              renderTextLayer={true}
              canvasBackground={"white"}
              scale={isMobile === false ? 1.5 : 0.7}
            />
          ))}
        </Document>
      </div>
    </div>
  );
};

export default DetailsModal;
